const sampleData = {
  "agriculture": {
    displayName: "Agriculture, Forestry, Fishing and Hunting",
    loanAmount: "$2,000,000",
    maturity: "9 Years",
    interestRate: "6.5%",
    monthlyPayment: "$24,509",
    id: 0,
  },
  "mining": {
    displayName: "Mining, Quarrying, and Oil and Gas Extraction",
    loanAmount: "$2,000,000",
    maturity: "9 Years",
    interestRate: "6.5%",
    monthlyPayment: "$24,509",
    id: 1,
  },
  "utilities": {
    displayName: "Utilities",
    loanAmount: "$3,000,000",
    maturity: "8 Years",
    interestRate: "1.2%",
    monthlyPayment: "$32,789",
    id: 2,
  },
  "construction": {
    displayName: "Construction",
    loanAmount: "1,000,000",
    maturity: " 10 Years",
    interestRate: "7.5%",
    monthlyPayment: "$411,870",
    id: 3,
  },
  "manufacturing": {
    displayName: "Manufacturing",
    loanAmount: "$4,000,000",
    maturity: "5 Years",
    interestRate: "5%",
    monthlyPayment: "$75,484",
    id: 4,
  },
  "wholesaleTrade": {
    displayName: "Wholesale Trade",
    loanAmount: "$3,000,000",
    maturity: "8 Years",
    interestRate: "1.2%",
    monthlyPayment: "$32,789",
    id: 5,
  },
  "retailTrade": {
    displayName: "Retail Trade",
    loanAmount: "$3,000,000",
    maturity: "8 Years",
    interestRate: "1.2%",
    monthlyPayment: "$32,789",
    id: 6,
  },
  "transportation": {
    displayName: "Transportation and Warehousing",
    loanAmount: "$3,000,000",
    maturity: "8 Years",
    interestRate: "1.2%",
    monthlyPayment: "$32,789",
    id: 7,
  },
  "information": {
    displayName: "Software (SaaS or IT)",
    loanAmount: "$4,000,000",
    maturity: "7 Years",
    interestRate: "8.9%",
    monthlyPayment: "$64,153",
    id: 8,
  },
  "finance": {
    displayName: "Finance and Insurance",
    loanAmount: "$5,000,000",
    maturity: "6 Years",
    interestRate: "7.3%",
    monthlyPayment: "$85,967",
    id: 9,
  },
  "realEstate": {
    displayName: "Real Estate and Rental and Leasing",
    loanAmount: "$5,000,000",
    maturity: "6 Years",
    interestRate: "7.3%",
    monthlyPayment: "$85,967",
    id: 10,
  },
  "professional": {
    displayName: "Professional, Scientific, and Technical Services",
    loanAmount: "$6,000,000",
    maturity: "5 Years",
    interestRate: "3%",
    monthlyPayment: "$107,812",
    id: 11,
  },
  "management": {
    displayName: "Management of Companies and Enterprises",
    loanAmount: "$6,000,000",
    maturity: "5 Years",
    interestRate: "3%",
    monthlyPayment: "$107,812",
    id: 12,
  },
  "administrative": {
    displayName:
      "Administrative and Support and Waste Management and Remediation Services",
    loanAmount: "$6,000,000",
    maturity: "5 Years",
    interestRate: "3%",
    monthlyPayment: "$107,812",
    id: 13,
  },
  "education": {
    displayName: "Educational Services",
    loanAmount: "$7,000,000",
    maturity: "4 Years",
    interestRate: "5%",
    monthlyPayment: "$161,205",
    id: 14,
  },
  "healthCare": {
    displayName: "Health Care and Social Assistance",
    loanAmount: "$8,000,000",
    maturity: "3 Years",
    interestRate: "2.4%",
    monthlyPayment: "$230,540",
    id: 15,
  },
  "recreation": {
    displayName: "Arts, Entertainment, and Recreation",
    loanAmount: "$9,000,000",
    maturity: "2 Years",
    interestRate: "4.8%",
    monthlyPayment: "$394,036",
    id: 16,
  },
  "accomodation": {
    displayName: "Accommodation and Food Services",
    loanAmount: "$9,000,000",
    maturity: "2 Years",
    interestRate: "4.8%",
    monthlyPayment: "$394,036",
    id: 17,
  },
  "other": {
    displayName: "Other Services (Except Public Administration)",
    loanAmount: "$10,000,000",
    maturity: "1 Years",
    interestRate: "4.61%",
    monthlyPayment: "$854,289",
    id: 18,
  },
  "publicAdmin": {
    displayName: "Public Administration",
    loanAmount: "$2,000,000",
    maturity: "3 Years",
    interestRate: "6%",
    monthlyPayment: "$60,844",
    id: 19,
  },
};
export default sampleData;
